export const DEFAULT_AVG_WORK_TIME_SECONDS = 1800;

export function workTimeLevel(seconds: number, averageSeconds: number) {
  return seconds >= averageSeconds * 2
    ? ("critical" as const)
    : seconds >= averageSeconds
    ? ("warning" as const)
    : ("normal" as const);
}
